import { Colour, Tile, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { useNavigate } from 'react-router';
import { faShare } from '@fortawesome/pro-solid-svg-icons/faShare';
import { IssueEntryType } from '../AccountIssuesTypes';

function ForwardingBatchesIssueEntry(props: IssueEntryType) {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<Tile
			onClick={() => navigate('./mail/forwarding-batches', { state: { status: 1 } })}
			title={t('accountIssues.labels.forwardingBatches')}
			description={t('accountIssues.counts.batch', {
				count: props.count,
			})}
			icon={faShare}
			isHorizontal
			colour={Colour.Alert}
		/>
	);
}

export { ForwardingBatchesIssueEntry };
